import { render } from "./index.vue?vue&type=template&id=d675c3de&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=d675c3de&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-d675c3de"

export default script